// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a778890d","249":"9b15b2e6","333":"e07b7769","382":"85515ae9","397":"f4f3387b","485":"538be0a3","540":"b68c95f9","672":"6fc76153","730":"3f69a026","751":"6ebee0fb","773":"debca453","828":"1ff92209"}[chunkId] + ".chunk.js";
};